import { useFeatureValue } from '@shared/core/featureFlags';

export function useIsHotelBlockAccommodationsFlagEnabled(): boolean {
  return useFeatureValue('hotelBlockEnabled').value === 'on';
}

export function useShouldShowSettingsOnComingSoonScreen(): boolean {
  return !useIsHotelBlockAccommodationsFlagEnabled();
}
